import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import SEO from './SEO.js';
import './AboutUs.css';

const AboutUs = () => {
  const teamMembers = [
    {
      id: 1,
      name: 'Dr. Sarah Johnson',
      role: 'Founder & Medical Director',
      bio: 'With over 15 years of experience in healthcare, Dr. Johnson founded Caremetto with a vision to bring quality healthcare to patients\'s homes.',
      image: '/images/doctor.jpg'
    },
    {
      id: 2,
      name: 'Michael Roberts',
      role: 'Chief Operations Officer',
      bio: 'Michael oversees all operational aspects of Caremetto, ensuring seamless service delivery and patient satisfaction.',
      image: '/images/doctor-consult.jpg'
    },
    {
      id: 3,
      name: 'Emily Chen',
      role: 'Head of Nursing',
      bio: 'Emily leads our team of skilled nurses, bringing her expertise in patient care and team management to deliver exceptional nursing services.',
      image: '/images/nursing.jpg'
    }
  ];

  return (
    <div className="about-section" id="about">
      <Container>
        <div className="section-header text-center">
          <h2>About Us</h2>
          <p>Learn about our mission and the team behind Caremetto</p>
        </div>

        <Row className="mb-5">
          <Col lg={6} className="mb-4 mb-lg-0">
            <div className="about-image">
              <img src="/images/doctor-consult.jpg" alt="Caremetto Team" className="img-fluid rounded shadow" />
            </div>
          </Col>
          <Col lg={6}>
            <div className="about-content">
              <h3>Our Story</h3>
              <p>
                Caremetto Healthcare was born from a simple idea — to help others. In 2019, when busy lifestyles left people with little time to care for their loved ones, we launched Caremetto as a platform to make seeking and offering help easier.              </p>
              <p>
                From assisting with daily tasks to supporting families during the COVID-19 pandemic with medicine deliveries and vaccination help, Caremetto quickly became a trusted companion. Over time, we noticed that most requests came from the elderly or families looking for reliable care for their senior members.              </p>
              <p> 
                With personal experience of having senior parents living alone, we deeply understood these challenges. This inspired us to shape Caremetto into a dedicated home healthcare service, focused on providing compassionate, on-demand support for seniors and their families.
              </p>
              <p>
                Today, Caremetto Healthcare continues to stand for trust, care, and commitment — ensuring your loved ones are always in safe hands.
              </p>
              <div className="about-values">
                <Row>
                  <Col md={4}>
                    <div className="value-item">
                      <i className="fas fa-heart"></i>
                      <h4>Compassion</h4>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="value-item">
                      <i className="fas fa-medal"></i>
                      <h4>Excellence</h4>
                    </div>
                  </Col>
                  <Col md={4}>
                    <div className="value-item">
                      <i className="fas fa-hands-helping"></i>
                      <h4>Integrity</h4>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Col>
        </Row>

        <div className="mission-vision">
          <Row>
            <Col md={6} className="mb-4 mb-md-0">
              <Card className="mission-card h-100">
                <Card.Body>
                  <div className="mission-icon">
                    <i className="fas fa-bullseye"></i>
                  </div>
                  <Card.Title>Our Mission</Card.Title>
                  <Card.Text>
                    To provide exceptional healthcare services in the comfort of patients' homes, enhancing their quality of life through personalized care, advanced medical expertise, and compassionate support.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card className="vision-card h-100">
                <Card.Body>
                  <div className="vision-icon">
                    <i className="fas fa-eye"></i>
                  </div>
                  <Card.Title>Our Vision</Card.Title>
                  <Card.Text>
                    To revolutionize home healthcare by making it accessible, affordable, and of the highest quality, becoming the most trusted name in home healthcare services nationwide.
                  </Card.Text>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </div>

        {/* <div className="team-section mt-5">
          <div className="section-subheader text-center mb-4">
            <h3>Meet Our Leadership Team</h3>
            <p>The dedicated professionals guiding our mission</p>
          </div>

          <Row>
            {teamMembers.map((member) => (
              <Col lg={4} md={6} sm={12} key={member.id} className="mb-4">
                <Card className="team-card h-100">
                  <div className="team-image">
                    <img src={member.image} alt={member.name} />
                  </div>
                  <Card.Body className="text-center">
                    <Card.Title className="member-name">{member.name}</Card.Title>
                    <div className="member-role">{member.role}</div>
                    <Card.Text className="member-bio">{member.bio}</Card.Text>
                    <div className="social-icons">
                      <a href="#" className="social-icon"><i className="fab fa-linkedin"></i></a>
                      <a href="#" className="social-icon"><i className="fab fa-twitter"></i></a>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </div> */}
      </Container>
    </div>
  );
};

export default AboutUs;